import { ResetPassword } from 'components'
import { AgendaProvider } from 'context'
import {
	AdminOrganization,
	Agenda,
	AppBuilds,
	Content,
	CreateApp,
	CreateContent,
	CreateLocation,
	Dashboard,
	Location,
	Login,
	MyNetwork,
	MyOrganization,
	MyPeople,
	PeopleBatches,
	Settings,
	SuperAdminDashboard,
	SuperAdminSettings,
	Versions
} from 'pages'
import { PushNotification } from 'pages/PushNotification'

import {
	ContenManager,
	MyNetworkManager,
	MyPeopleManager,
	NoAuth,
	RequireUser,
	SuperAdminUser
} from 'provider'
import { getOrgInfo } from 'api/get/people'
import React, { useMemo, useState } from 'react'
import { useQuery } from 'react-query'
import { Route, Routes } from 'react-router-dom'
import Cookies from 'universal-cookie'

export const RoutesElements = (): JSX.Element => {
	const cookies = new Cookies()
	const isSuperAdmin = cookies.get('isSuperAdmin')
	const organizationId = cookies.get('organization_id') as number

	const { data: orgInfo } = useQuery(
		['orgInfo', organizationId],
		() => getOrgInfo(organizationId),
		{ enabled: !!organizationId && !isSuperAdmin }
	)

	const isMyNetworkEnabled =
		isSuperAdmin || orgInfo?.active_my_network !== false

	const [messageDashboard, setMessageDashboard] = useState<string>('')

	const optionsToRender = useMemo(
		() => [
			{ name: 'My People', value: 'My People' },
			{ name: 'My Lists', value: 'My Lists' },
			{ name: 'My Tags', value: 'My Tags' }
		],
		[]
	)
	const [period, setPeriod] = useState(optionsToRender[0].value)
	const [tagApprovalModal, setTagApprovalModal] = useState(false)
	const networkOptionsToRender = useMemo(
		() => [
			{ name: 'Partners', value: 'Partners' },
			{ name: 'Partner Feeds', value: 'Partner Feeds' },
			{ name: 'My Feeds', value: 'My Feeds' }
		],
		[]
	)
	const [networkPeriod, setNetworkPeriod] = useState(
		networkOptionsToRender[0].value
	)

	const currentContenOptionsToRender = useMemo(
		() => [
			{ name: 'Content Items', value: 'Content Items' },
			{ name: 'Push', value: 'Direct Pushes' }
		],
		[]
	)
	const onlyContenOptionsToRender = useMemo(
		() => [{ name: 'Content Items', value: 'Content Items' }],
		[]
	)
	const partnerContenOptionsToRender = useMemo(
		() => [
			{ name: 'Content Items', value: 'Content Items' },
			{ name: 'Push', value: 'Partner Pushes' }
		],
		[]
	)
	const [contentPeriod, setContentPeriod] = useState(
		currentContenOptionsToRender[0].value
	)

	const contenOrPartnertOptionsToRender = useMemo(() => {
		const options = [
			{ name: 'My Content', value: 'My Content' },
			{ name: 'Partner Content', value: 'Partner Content' }
		]
		return isMyNetworkEnabled
			? options
			: options.filter(o => o.value !== 'Partner Content')
	}, [isMyNetworkEnabled])
	const [contenOrPartnert, setContenOrPartnert] = useState(
		contenOrPartnertOptionsToRender[0].value
	)

	React.useEffect(() => {
		if (!isMyNetworkEnabled && contenOrPartnert === 'Partner Content') {
			setContenOrPartnert('My Content')
		}
	}, [isMyNetworkEnabled, contenOrPartnert])

	return (
		<Routes>
			<Route
				path="/login"
				element={
					<NoAuth>
						<Login />
					</NoAuth>
				}
			/>
			<Route
				path="/resetPassword/:id"
				element={
					<NoAuth>
						<ResetPassword />
					</NoAuth>
				}
			/>
			{/* Admin */}
			<Route
				path="/"
				element={
					<RequireUser>
						<Dashboard
							setPeriod={setPeriod}
							setNetworkPeriod={setNetworkPeriod}
							setTagApprovalModal={setTagApprovalModal}
						/>
					</RequireUser>
				}
			/>
			<Route
				path="/content"
				element={
					<RequireUser>
						<ContenManager>
							<Content
								optionsToRender={currentContenOptionsToRender}
								period={contentPeriod}
								setPeriod={setContentPeriod}
								optionsToRenderTwo={contenOrPartnertOptionsToRender}
								periodMyContent={contenOrPartnert}
								setPeriodMyconten={setContenOrPartnert}
								optionsToRenderContent={partnerContenOptionsToRender}
								setMessageDashboard={setMessageDashboard}
							/>
						</ContenManager>
					</RequireUser>
				}
			/>
			<Route
				path="/content/create"
				element={
					<RequireUser>
						<ContenManager>
							<AgendaProvider>
								<CreateContent mode="create" />
							</AgendaProvider>
						</ContenManager>
					</RequireUser>
				}
			/>
			<Route
				path="/content/edit/:id"
				element={
					<RequireUser>
						<ContenManager>
							<AgendaProvider>
								<CreateContent mode="edit" />
							</AgendaProvider>
						</ContenManager>
					</RequireUser>
				}
			/>
			<Route
				path="/content/push-notification"
				element={
					<RequireUser>
						<ContenManager>
							<AgendaProvider>
								<PushNotification
									messageDashboard={messageDashboard}
									setMessageDashboard={setMessageDashboard}
								/>
							</AgendaProvider>
						</ContenManager>
					</RequireUser>
				}
			/>
			<Route
				path="/content/push-notification/edit/:id"
				element={
					<RequireUser>
						<ContenManager>
							<AgendaProvider>
								<PushNotification />
							</AgendaProvider>
						</ContenManager>
					</RequireUser>
				}
			/>
			<Route
				path="/content/agenda"
				element={
					<RequireUser>
						<ContenManager>
							<AgendaProvider>
								<Agenda />
							</AgendaProvider>
						</ContenManager>
					</RequireUser>
				}
			/>
			<Route
				path="/location"
				element={
					<RequireUser>
						<ContenManager>
							<Location
								optionsToRender={currentContenOptionsToRender}
								period={contentPeriod}
								setPeriod={setContentPeriod}
								optionsToRenderTwo={contenOrPartnertOptionsToRender}
								periodMyContent={contenOrPartnert}
								setPeriodMyconten={setContenOrPartnert}
								optionsToRenderContent={onlyContenOptionsToRender}
								setMessageDashboard={setMessageDashboard}
							/>
						</ContenManager>
					</RequireUser>
				}
			/>
			<Route
				path="/location/create"
				element={
					<RequireUser>
						<ContenManager>
							<CreateLocation mode="create" />
						</ContenManager>
					</RequireUser>
				}
			/>
			<Route
				path="/location/edit/:id"
				element={
					<RequireUser>
						<ContenManager>
							<CreateLocation mode="edit" />
						</ContenManager>
					</RequireUser>
				}
			/>
			<Route
				path="/people"
				element={
					<RequireUser>
						<MyPeopleManager>
							<MyPeople
								period={period}
								setPeriod={setPeriod}
								optionsToRender={optionsToRender}
								tagApprovalModal={tagApprovalModal}
								setTagApprovalModal={setTagApprovalModal}
							/>
						</MyPeopleManager>
					</RequireUser>
				}
			/>
			<Route
				path="/people/edit"
				element={
					<RequireUser>
						<MyPeopleManager>
							<PeopleBatches />
						</MyPeopleManager>
					</RequireUser>
				}
			/>
			<Route
				path="/network"
				element={
					<RequireUser>
						<MyNetworkManager>
							<MyNetwork
								optionsToRender={networkOptionsToRender}
								period={networkPeriod}
								setPeriod={setNetworkPeriod}
							/>
						</MyNetworkManager>
					</RequireUser>
				}
			/>
			<Route
				path="/organization"
				element={
					<RequireUser>
						<ContenManager>
							<MyOrganization />
						</ContenManager>
					</RequireUser>
				}
			/>
			<Route
				path="/settings"
				element={
					<RequireUser>
						<Settings />
					</RequireUser>
				}
			/>
			{/* Super Admin */}
			<Route
				path="/superAdmin/organization"
				element={
					<RequireUser>
						<SuperAdminUser>
							<SuperAdminDashboard />
						</SuperAdminUser>
					</RequireUser>
				}
			/>
			<Route
				path="/superAdmin/organization/create"
				element={
					<RequireUser>
						<SuperAdminUser>
							<AdminOrganization />
						</SuperAdminUser>
					</RequireUser>
				}
			/>
			<Route
				path="/superAdmin/settings"
				element={
					<RequireUser>
						<SuperAdminSettings />
					</RequireUser>
				}
			/>
			<Route
				path="/superAdmin/appBuilds"
				element={
					<RequireUser>
						<SuperAdminUser>
							<AppBuilds />
						</SuperAdminUser>
					</RequireUser>
				}
			/>
			<Route
				path="/superAdmin/appBuilds/version/:id"
				element={
					<RequireUser>
						<SuperAdminUser>
							<Versions />
						</SuperAdminUser>
					</RequireUser>
				}
			/>
			<Route
				path="/superAdmin/appBuilds/create-app"
				element={
					<RequireUser>
						<SuperAdminUser>
							<CreateApp />
						</SuperAdminUser>
					</RequireUser>
				}
			/>
		</Routes>
	)
}
